import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router';

import Container from '@mui/material/Container';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { paths } from 'src/routes/paths';


import { _userList, _roles, USER_STATUS_OPTIONS } from 'src/_mock';

import Iconify from 'src/components/iconify';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useTable, getComparator } from 'src/components/table';
// types
import { IUserTableFilters, IUserTableFilterValue } from 'src/types/user';
//

import { Iappuser } from 'src/types/product';
import Adminuserviewdetails from './admin-user-profile-view';

// import Adminuserviewdetails from './admin-user-profile-view';

const defaultFilters: IUserTableFilters = {
  name: '',
  role: [],
  status: 'all',
};

// ----------------------------------------------------------------------

export default function AdminUserViewDetails() {
  const params = useParams();

  const { id } = params;
  const [currentTab, setCurrentTab] = useState('General');

  const TABS = [
    {
      value: 'General',
      label: 'General',
      icon: <Iconify icon="mdi:card-account-details" width={24} />,
    },
  ];
  const table = useTable();

  const settings = useSettingsContext();

  const [tableData, setTableData] = useState<Iappuser[]>([]);

  const [filters, setFilters] = useState(defaultFilters);

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });

  const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  }, []);
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Admin User"
          links={[
           {}
          ]}
          sx={{
            mb: { xs: 1, md: 1 },
          }}
        />
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          sx={{
            mb: { xs: 1, md: 1 },
          }}
        >
          {TABS.map((tab) => (  
            <Tab key={tab.value} label={tab.label} icon={tab.icon} value={tab.value} />
          ))}
        </Tabs>

        {currentTab === 'General' && <Adminuserviewdetails id={id} />}
      </Container>
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter({
  inputData,
  comparator,
  filters,
}: {
  inputData: Iappuser[];
  comparator: (a: any, b: any) => number;
  filters: IUserTableFilters;
}) {
  const { name, status, role } = filters;

  const stabilizedThis = inputData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);
  return inputData;
}
